/**
 * @generated SignedSource<<c292c4d0e03b021f345737b5f2550902>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CryptoAddressHostType = "KNOWN_VASP" | "SELF_HOSTED" | "UNKNOWN_VASP";
export type OwnerType = "LEGAL_ENTITY" | "NATURAL_PERSON" | "NONE";
export type UpdateExternalCryptoAddressInput = {
  hostId?: string | null | undefined;
  hostName?: string | null | undefined;
  hostType: CryptoAddressHostType;
  id: string;
  ownerIdentifier?: string | null | undefined;
  ownerLegalName?: string | null | undefined;
  ownerType?: OwnerType | null | undefined;
  userOwned: boolean;
};
export type UpdateExternalCryptoAddressMutation$variables = {
  input?: UpdateExternalCryptoAddressInput | null | undefined;
};
export type UpdateExternalCryptoAddressMutation$data = {
  readonly updateExternalCryptoAddress: {
    readonly address: string;
    readonly createdAt: TimeScalar | null | undefined;
    readonly id: string;
  } | null | undefined;
};
export type UpdateExternalCryptoAddressMutation = {
  response: UpdateExternalCryptoAddressMutation$data;
  variables: UpdateExternalCryptoAddressMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CryptoAddress",
    "kind": "LinkedField",
    "name": "updateExternalCryptoAddress",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "address",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateExternalCryptoAddressMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateExternalCryptoAddressMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d8687232c938297d4e5538ecfa78f5e2",
    "id": null,
    "metadata": {},
    "name": "UpdateExternalCryptoAddressMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateExternalCryptoAddressMutation(\n  $input: UpdateExternalCryptoAddressInput\n) {\n  updateExternalCryptoAddress(input: $input) {\n    id\n    address\n    createdAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "bdafae290be692ffe693f709ba4a4ebb";

export default node;
